import React, { useEffect, useState } from "react";
import { referenceimage } from "../svg/iconsvg";
import { getInitials } from "../../utils/generatefilename";
import ToastMessage from "../../utils/mui/righttoptoast";
import { useSelector } from "react-redux";
import dayjs from "dayjs";
import api from "../../api/api";

const ProfileCard = ({
  isOpen,
  onClose,
  colors,
  profile,
  onSave,
}) => {

  /* -------------------- FORM DATA -------------------- */
  const [formData, setFormData] = useState({
    referencenumber: "",
    copay: "",
    coinsurance: "",
    deductible: "",
    benefits: [],
  });

  /* -------------------- TOAST -------------------- */
  const [openToast, setOpenToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const practiseid = window.getPracticeId();
     const [getpaymentData, setGetpaymentData] = useState(null);
     
const userConfig = useSelector((state) => state.userconfig);
  const showToast = (msg) => {
    setToastMessage(msg);
    setOpenToast(true);
  };

  const handleToastClose = () => setOpenToast(false);
   
  const handleGetPayment = async ({ data }) => {
    if(!data?.appointment_date)return
    const dateString = data?.appointment_date;
    const formattedDate = new Date(dateString).toLocaleDateString('en-CA');
    try {
      const response = await api.post(`/v1/${practiseid}/patient/${data?.patientid}/view-payments`, {
        appointmentid: data.appointmentid,
        startdate: formattedDate,
      });
      if (response.status === 200) {
        setGetpaymentData(response.data);
       setFormData({
  ...formData,
  copay: Number(response?.data?.copay) || 0,
  deductible: Number(response?.data?.deductibleamt) || 0,
  coinsurance: Number(response?.data?.coinsurance) || 0,
});
      }else{
        setGetpaymentData('')
      }
    } catch (error) {
      console.error('Error fetching payment:', error);
    }
  };
  /* -------------------- INIT / PREFILL -------------------- */
  useEffect(() => {

    setFormData({
      referencenumber: String(
        profile?.ins_config?.referencenumber ?? ""
      ),
      copay: String(profile?.ins_config?.copay ?? ""),
      coinsurance: String(profile?.ins_config?.coinsurance ?? ""),
      deductible: String(profile?.ins_config?.deductible ?? ""),
      benefits: profile?.ins_config?.benefits || [],
    });
    handleGetPayment({data:profile})
  }, [profile]);

  if (!isOpen || !profile) return null;

  /* -------------------- DECIMAL INPUT HANDLER -------------------- */
  const handleDecimalChange = (key, value) => {
    if (/^\d*\.?\d*$/.test(value)) {
      setFormData((prev) => ({
        ...prev,
        [key]: value,
      }));
    }
  };

  /* -------------------- BENEFITS -------------------- */
  const toggleBenefit = (benefit) => {
    setFormData((prev) => ({
      ...prev,
      benefits: prev.benefits.includes(benefit)
        ? prev.benefits.filter((b) => b !== benefit)
        : [...prev.benefits, benefit],
    }));
  };
  const toNumber = (v) => {
  const n = Number(v);
  return Number.isFinite(n) ? n : 0;
};
const handleUpdatePay = async (currentPatient) => {
  const formattedStartDate = dayjs(currentPatient.startdate).format("YYYY-MM-DD");

  // 👇 PRIORITY: formData → API → 0
  const copay =
    toNumber(formData.copay) ||
    toNumber(getpaymentData?.data?.copay);

  const deductible =
    toNumber(formData.deductible) ||
    toNumber(getpaymentData?.deductibleamt);

  const coinsurance =
    toNumber(formData.coinsurance) ||
    toNumber(getpaymentData?.coinsurance);

  const selfpay = toNumber(getpaymentData?.selfpay);
  const acctbalance = toNumber(getpaymentData?.acctbalance);

  const initialTotal =
    copay +
    deductible +
    selfpay +
    acctbalance;

  const payload = {
    patientname: `${currentPatient.firstname} ${currentPatient.lastname}`,
    appointmentid: currentPatient.appointmentid,
    location: "Practice App",
    insurance: currentPatient.insurancename || "",

    // ✅ INPUT FIELD PRIORITY VALUES
    copay: copay,
    deductibleamt: deductible,
    coinsurancepercent: coinsurance,

    selfpaybalance: selfpay,
    accountbalance: acctbalance,

    amount: initialTotal,
    searchdate: formattedStartDate,
    createdby: userConfig?.username,
  };

  try {
    await api.put(
      `/v1/${practiseid}/patient/${currentPatient.patientid}/payments/updatepaymentupdate`,
      payload
    );
  } catch (error) {
    console.error("Error submitting payment:", error);
  }
};

// const handleUpdatePay = async (currentPatient) => {
//     const formattedStartDate = dayjs(currentPatient.startdate).format('YYYY-MM-DD');
//        const initialTotal =
//   toNumber(getpaymentData?.data?.copay) +
//   toNumber(getpaymentData?.selfpay) +
//   toNumber(getpaymentData?.deductibleamt) +
//   toNumber(getpaymentData?.acctbalance);

//     let totalAfter = initialTotal;
//     const payload = {
//       patientname: `${currentPatient.firstname} ${currentPatient.lastname}`,
//       appointmentid: currentPatient.appointmentid,
//       location: "Practice App",
//       insurance: currentPatient.insurancename||'',
//        copay: Number(getpaymentData?.data?.copay) || 0,
//   deductibleamt: Number(getpaymentData?.deductibleamt) || 0,
//   // coinsurance: Number(response?.data?.coinsurance) || 0,    
//       accountbalance: getpaymentData.acctbalance || 0.0,
//        coinsurancepercent: formData.coinsurance||0.0,
//       selfpaybalance: getpaymentData?.selfpay || 0.0,
//       amount: totalAfter || 0.0,
//       searchdate: formattedStartDate,
//       createdby: userConfig?.username,
//     };

//     try {
//       const response = await api.put(`/v1/${practiseid}/patient/${currentPatient.patientid}/payments/updatepaymentupdate`, payload);
//     } catch (error) {
//       console.error("Error submitting payment:", error);
//     }
//   };
  /* -------------------- SAVE -------------------- */
  const handleSave = () => {
if (!formData.referencenumber?.trim())
  return showToast("Reference Number is mandatory");

if (Number(formData.copay) <= 0)
  return showToast("Co-Pay Amount is mandatory");

if (Number(formData.coinsurance) <= 0)
  return showToast("Coinsurance is mandatory");

if (Number(formData.deductible) <= 0)
  return showToast("Deductible Amount is mandatory");

handleUpdatePay(profile)
    onSave({
      patientid: profile.patientid,
       "ins_status": "P",
        isexit:true,
      ins_config: {
        referencenumber: formData.referencenumber,
        copay: formData.copay,
        coinsurance: formData.coinsurance,
        deductible: formData.deductible,
        benefits: formData.benefits,
        updatedby:userConfig?.username,
        updatedon: dayjs().toISOString(),
      },
    });
  };

  const inputClass =
    "mt-1 w-full rounded-[10px] border border-[#D1D5DC] px-3 py-2 text-sm focus:outline-none";

  return (
    <div className="fixed inset-0 z-50 bg-black/40 overflow-y-auto">
      <div className="min-h-screen flex items-start justify-center py-10">
        <div className="w-[360px] rounded-[14px] bg-white shadow-lg">

          {/* ---------------- HEADER ---------------- */}
          <div className="flex items-center justify-between rounded-t-[14px] bg-[#1D2951] px-4 py-3 text-white">
            <div className="flex items-center gap-3">
           <div
  className="relative flex h-9 w-9 items-center justify-center rounded-full text-sm font-semibold text-[#1D2951] overflow-hidden"
  style={{
    backgroundColor: colors?.[profile?.ins_status] || "#9CA3AF",
  }}
>
  <img
    src={`/cloud-assets/chim/public/assets/images/profilepictures/${profile?.patientid}.png`}
    alt={`${profile?.firstname} ${profile?.lastname}`}
    className="absolute inset-0 h-full w-full object-cover"
    onLoad={(e) => {
      // hide initials when image loads
      e.target.nextSibling.style.display = "none";
    }}
    onError={(e) => {
      // hide broken image, keep initials
      e.target.style.display = "none";
    }}
  />

  {/* Initials fallback */}
  <span className="relative z-10">
    {getInitials(profile?.firstname, profile?.lastname)}
  </span>
</div>


              <div className="text-sm text-start">
                <p className="font-semibold">
                  {profile.firstname} {profile.lastname}
                </p>
                <p className="text-xs opacity-80">
                  {profile.insurance || "-"}
                </p>

                <div className="flex gap-4 items-center">
                  <span className="text-xs opacity-80">
                    Subscriber ID: {profile.subscriber_id || "-"}
                  </span>
                  <span className="text-xs opacity-80">
                    Group ID: {profile.group_id || "-"}
                  </span>
                </div>
              </div>
            </div>

            <button onClick={onClose} className="text-lg font-bold">
              ×
            </button>
          </div>

          {/* ---------------- BODY ---------------- */}
          <div className="space-y-4 text-start p-4 text-sm">

            {/* Patient Insurance */}
            <div className="flex flex-col rounded-[10px] border border-[#D1D5DC] px-3 py-2">
              <label className="text-xs text-gray-500">
                Patient Insurance
              </label>
              <div className="mt-1 text-sm font-medium text-gray-800">
                {profile.insurance || "-"}
              </div>
            </div>

            {/* Reference Number */}
            <div className="flex flex-col">
              <label className="text-xs text-gray-500">
                Reference Number *
              </label>
              <div className="mt-1 flex items-center gap-2 border rounded-[10px] px-3 py-2">
                {referenceimage}
                <input
                  value={formData.referencenumber}
                  onChange={(e) =>
                    setFormData((p) => ({
                      ...p,
                      referencenumber: e.target.value,
                    }))
                  }
                  className="w-full focus:outline-none"
                  placeholder="Enter reference number"
                />
              </div>
            </div>

            {/* Co-Pay */}
            <div>
              <label className="text-xs text-gray-500">
                Co-Pay Amount *
              </label>
              <input
                className={inputClass}
                value={formData.copay}
                onChange={(e) =>
                  handleDecimalChange("copay", e.target.value)
                }
                placeholder="$0.00"
                inputMode="decimal"
              />
            </div>

            {/* Coinsurance */}
            <div>
              <label className="text-xs text-gray-500">
                Coinsurance (%) *
              </label>
              <input
                className={inputClass}
                value={formData.coinsurance}
                onChange={(e) =>
                  handleDecimalChange("coinsurance", e.target.value)
                }
                placeholder="0"
                inputMode="decimal"
              />
            </div>

            {/* Deductible */}
            <div>
              <label className="text-xs text-gray-500">
                Deductible Amount *
              </label>
              <input
                className={inputClass}
                value={formData.deductible}
                onChange={(e) =>
                  handleDecimalChange("deductible", e.target.value)
                }
                placeholder="$0.00"
                inputMode="decimal"
              />
            </div>

            {/* Covered Benefits */}
            <div>
              <label className="text-xs text-gray-500">
                Covered Benefits *
              </label>
              <div className="mt-2 space-y-2 border rounded-[10px] p-3 text-xs">
                {[
                  "Visit",
                  "Labs",
                  "EKG",
                  "Ultrasound",
                  "Sleep Study",
                  "Echo",
                  "Injection",
                ].map((b) => (
                  <label key={b} className="flex gap-2">
                    <input
                      type="checkbox"
                      checked={formData.benefits.includes(b)}
                      onChange={() => toggleBenefit(b)}
                    />
                    {b}
                  </label>
                ))}
              </div>
            </div>
          </div>

          {/* ---------------- FOOTER ---------------- */}
          <div className="flex gap-2 border-t px-4 py-3">
            <button
              onClick={onClose}
              className="w-full rounded-[10px] border px-4 py-2"
            >
              Cancel
            </button>
            <button
              onClick={handleSave}
              className="w-full rounded-[10px] bg-[#1D2951] px-4 py-2 text-white"
            >
              Save
            </button>
          </div>
        </div>
      </div>

      {/* TOAST */}
      <ToastMessage
        open={openToast}
        message={toastMessage}
        severity="error"
        handleClose={handleToastClose}
      />
    </div>
  );
};

export default ProfileCard;
